import React from 'react'
import { Col, Grid, Skeleton } from 'gu-ui-kit'
export const Placeholder = () => (
  <Skeleton shown>
    <Grid
      className={'margin-bottom-16'}
      gap={16}
    >
      <Skeleton.Item
        height={32}
        width={150}
      />
      <Skeleton.Item
        height={32}
        width={150}
      />
    </Grid>
    <Grid
      className={'margin-bottom-32'}
      gap={16}
      wrap={false}
    >
      <Skeleton.Item
        height={52}
        width={'100%'}
      />
      <Skeleton.Item
        height={52}
        width={'100%'}
      />
    </Grid>

    <Grid
      className={'margin-bottom-16'}
      gap={16}
      wrap={false}
    >
      <Col>
        <Skeleton.Item
          height={44}
          width={44}
        />
      </Col>
      <Grid
        direction={'column'}
        gap={4}
      >
        <Skeleton.Item
          height={20}
          width={'100%'}
        />
        <Grid gap={16}>
          <Skeleton.Item
            height={20}
            width={60}
          />
          <Skeleton.Item
            height={20}
            width={200}
          />
        </Grid>
      </Grid>
    </Grid>
    <Grid className={'margin-bottom-16'}>
      <Skeleton.Item
        height={40}
        width={'100%'}
      />
    </Grid>
    <Grid className={'margin-bottom-16'}>
      <Skeleton.Item
        height={1}
        width={'100%'}
      />
    </Grid>
    <Grid
      className={'margin-bottom-16'}
      gap={16}
      wrap={false}
    >
      <Col>
        <Skeleton.Item
          height={44}
          width={44}
        />
      </Col>
      <Grid
        direction={'column'}
        gap={4}
      >
        <Skeleton.Item
          height={20}
          width={'100%'}
        />
        <Grid gap={16}>
          <Skeleton.Item
            height={20}
            width={60}
          />
          <Skeleton.Item
            height={20}
            width={200}
          />
        </Grid>
      </Grid>
    </Grid>

    <Grid className={'margin-bottom-16'}>
      <Skeleton.Item
        height={40}
        width={'100%'}
      />
    </Grid>
    <Grid className={'margin-bottom-16'}>
      <Skeleton.Item
        height={1}
        width={'100%'}
      />
    </Grid>
    <Grid
      className={'margin-bottom-16'}
      gap={16}
      wrap={false}
    >
      <Col>
        <Skeleton.Item
          height={44}
          width={44}
        />
      </Col>
      <Grid
        direction={'column'}
        gap={4}
      >
        <Skeleton.Item
          height={20}
          width={'100%'}
        />
        <Grid gap={16}>
          <Skeleton.Item
            height={20}
            width={60}
          />
          <Skeleton.Item
            height={20}
            width={200}
          />
        </Grid>
      </Grid>
    </Grid>
    <Grid>
      <Skeleton.Item
        height={40}
        width={'100%'}
      />
    </Grid>
  </Skeleton>
)
